export default [
  {
    label: "Service order No.",
    name: "serviceOrderNumber",
    type: "text",
    required: true,
  },
  {
    label: "วันที่",
    name: "date",
    type: "date",
  },
  {
    label: "ประเภท",
    name: "serviceType",
    type: "select",
    options: ["repair", "maintenance", "cleaning", "other"],
  },
  {
    label: "Serial No.",
    name: "sn",
    type: "search",
    required: true,
  },
  {
    label: "HN",
    name: "hn",
    type: "text",
    autoFilled: true,
  },
  {
    label: "ยี่ห้อ",
    name: "brand",
    type: "text",
    autoFilled: true,
  },
  {
    label: "รุ่น",
    name: "model",
    type: "text",
    autoFilled: true,
  },
  {
    label: "ประเภทเครื่อง",
    name: "cpapType",
    type: "text",
    autoFilled: true,
  },
  {
    label: "รายการอุปกรณ์",
    name: "accessories",
    type: "textarea",
  },
  {
    label: "รายละเอียดการส่งซ่อม",
    name: "description",
    type: "textarea",
  },
  { label: "รูปภาพประกอบ", name: "image", type: "file" },
  {
    label: "ผู้รับเครื่อง",
    name: "receiveBy",
    type: "text",
  },
  {
    label: "สถานะการดำเนินการ",
    name: "serviceStatus",
    type: "select",
    options: [
      "รับเครื่อง",
      "กำลังตรวจเช็ค",
      "รออะไหล่",
      "กำลังดำเนินการ",
      "ส่งซ่อมบริษัทนอก",
      "เสร็จสิ้น",
      "ยกเลิก",
    ],
  },
  {
    label: "รายละเอียดการดำเนินงาน",
    name: "serviceDetail",
    type: "textarea",
  },
  {
    label: "ราคา",
    name: "amount",
    type: "text",
  },
  {
    label: "วันที่ดำเนินการเสร็จสิ้น",
    name: "completionDate",
    type: "date",
  },
  {
    label: "ผู้ดำเนินการ",
    name: "serviceBy",
    type: "text",
  },
  {
    label: "Note",
    name: "note",
    type: "textarea",
  },
];
